// oass form validator
function initPostCodeHelper(fv, from, isCheckout = false, postcode, citycode) {
  let postCodeInput = from.querySelector(`[name="postcode"]`) || postcode;
  let cityInput = from.querySelector(`[name="city"]`) || citycode;
  const postCodeName = postCodeInput.getAttribute('name');
  const postCodeData = JSON.parse(localData.postCodes);
  const codesOnly = Object.keys(postCodeData).map((key) => key);

  if (postCodeInput) {
    fv.addField(postCodeName, {
      validators: {
        regexp: {
          enabled: false,
          regexp: /^[0-9]{4}$/,
          message: 'Vnesite veljavno poštno številko',
        },
        callback: {
          enabled: false,
          callback() {
            return !!codesOnly.find((code) => code === postCodeInput.value);
          },
          message: 'Številka ne obstaja',
        },
      },
    });
  }

  fv.on('core.form.validating', (e) => {
    if (postCodeInput && cityInput) {
      fv.enableValidator(postCodeName)
    }
  });
  const handlePostCodeInput = (type) => {
    const thisPostCode = postCodeInput;
    const thisCity = cityInput;

    const handleInput = (postCode, city) => {
      const activeAddress = document.querySelector('.cart-preview .address-list.show');
      if (postCode.value.length === 4) {
        if (fv) {
          fv.enableValidator(type);
          fv.validateField(type);
        }
        const key = parseInt(postCode.value, 10);
        if (key in postCodeData) {
          // eslint-disable-next-line no-param-reassign
          city.value = postCodeData[key];
          if (!activeAddress && isCheckout) {
            getShippingCost(key);
          }
        }
      } else {
        if (postCode.value.length < 4 && fv) {
          fv.disableValidator(type);
        }
        // eslint-disable-next-line no-param-reassign
        city.value = '';
        if (!activeAddress && isCheckout) {
          resetDeliveryCost();
          resetFinalAmount();
        }
      }
    };

    if (thisPostCode) {
      handleInput(thisPostCode, thisCity);
    }
  };

  if (postCodeInput) {
    postCodeInput.addEventListener('input', () => handlePostCodeInput(postCodeName));
  }
}
